export default __webpack_public_path__ + "static/media/magnifiying-glass 1.103157d5.svg";